module.exports = __webpack_public_path__ + "static/media/iPhoneX.6f2f9f37.png";